import React, { useEffect, useRef } from "react";
import logo from "../Assets/logo.png";

function LogoDisplay() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "auto",
        padding: "0",
        margin: "0",
      }}
    >
      <img
        src={logo}
        alt="Logo"
        style={{ width: "500px", height: "auto", margin: "0", padding: "0" }} // Ensure no margin and padding here as well
        className="fade-in"
      />
    </div>
  );
}

export default LogoDisplay;
